import DataTable from '@components/table/datatable';
import { UseMenuInterface } from '@hooks/useMenu';
import { IPrintQueue } from '@interfaces/pos-api.interface';
import { FiberManualRecord } from '@mui/icons-material';
import { Divider, Stack, Typography } from '@mui/material';
import {
  GridColDef,
  GridPagination,
  GridRowId,
  GridRowSelectionModel,
} from '@mui/x-data-grid';
import { dateTimeFormat } from '@utils/format';
import moment from 'moment';
import { useCallback } from 'react';

const columns: GridColDef[] = [
  { field: 'docType', headerName: 'Document', minWidth: 110 },
  { field: 'printedByUser', headerName: 'Printed By', minWidth: 160 },
  {
    field: 'docRequestDate',
    headerName: 'Submitted',
    minWidth: 160,
    valueFormatter(params) {
      return moment(params.value).format(dateTimeFormat);
    },
  },
  { field: 'printerStatus', headerName: 'Status', minWidth: 150 },
];

const PrintQueueDatatable = ({
  selectedRowsState,
  menu,
  isLoading,
  data,
}: {
  selectedRowsState: [
    GridRowId[],
    React.Dispatch<React.SetStateAction<GridRowId[]>>,
  ];
  isLoading: boolean;
  data: IPrintQueue[];
  menu: UseMenuInterface;
}) => {
  const { handleContextMenu, handleTouchEnd, handleTouchStart } = menu;
  const [selectedRows, setSelectedRows] = selectedRowsState;

  const handleSelectionChange = useCallback(
    (selectionModel: GridRowSelectionModel) => {
      setSelectedRows(selectionModel);
    },
    [],
  );

  return (
    <DataTable
      getRowId={(row) => row.printQueueID}
      columns={columns}
      rows={data}
      fullHeight
      tableStyle={{
        padding: 0,
        height: 'unset',
      }}
      wrapperStyle={{
        height: 'unset',
        display: 'flex',
        flex: 1,
        minHeight: 0,
      }}
      onRowSelectionModelChange={handleSelectionChange}
      rowSelectionModel={selectedRows}
      slots={{
        pagination: (props) => (
          <Stack
            direction='row'
            gap={3}
            sx={{ width: '100%', height: '100%', alignItems: 'center' }}
          >
            {false && (
              <>
                <Stack
                  direction='row'
                  gap={1}
                  sx={{ alignItems: 'center', whiteSpace: 'nowrap' }}
                >
                  <FiberManualRecord
                    sx={{ fontSize: '12px', color: 'success.main' }}
                  />
                  <Typography sx={{ fontSize: '12px', lineHeight: '17px' }}>
                    Connected to printer:
                  </Typography>
                </Stack>
                <Divider orientation='vertical' sx={{ height: '16px' }} />
              </>
            )}
            <GridPagination {...props} />
          </Stack>
        ),
      }}
      loading={isLoading}
      slotProps={{
        row: {
          onContextMenu: handleContextMenu,
          onTouchStart: handleTouchStart,
          onTouchEnd: handleTouchEnd,
          style: { cursor: 'context-menu' },
        },
      }}
    />
  );
};

export default PrintQueueDatatable;
